import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import { InputWrapper } from './css';
import { Box, Text } from '../../css';

const TypeAheadFilter = ({
  options,
  onChange,
  selected,
  label,
  placeholder,
  disabled
}) => {
  const ref = useRef();

  useEffect(() => {
    if (!selected.length) {
      ref.current.clear();
    }
  }, [selected]);

  return (
    <InputWrapper>
      <Box>
        <Text bold>{label}</Text>
        <Typeahead
          id="basic-typeahead"
          labelKey="label"
          options={options}
          onChange={onChange}
          placeholder={placeholder}
          selected={selected}
          ref={ref}
          disabled={disabled}
          clearButton
        />
      </Box>
    </InputWrapper>
  );
};

TypeAheadFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

TypeAheadFilter.defaultProps = {
  selected: [],
  disabled: false
};

export default TypeAheadFilter;
